module.exports = __webpack_public_path__ + "static/media/31.bd8b2dc2.jpg";